import actions from './actions';
import actionsNew from './actionsNew';
import mutations from './mutations';
import mutationsNew from './mutationsNew';
import getters from './getters';
import gettersNew from './gettersNew';
import state from './initialState';

const TasksStore = {
  namespaced: true,
  state,
  getters: { ...getters, ...gettersNew },
  mutations: { ...mutations, ...mutationsNew },
  actions: { ...actions, ...actionsNew },
};

export default TasksStore;
